import React, {useEffect, useState} from "react";
import AppHeader from "../../components/header";
import Footer from "../../components/footer";
import "./style.scss";
import {useDispatch, useSelector} from "react-redux";
import {getLoginConfig} from "../../redux/slices/loginconfigSlice";
import {useNavigate} from "react-router-dom";
import {setActivityIndicator} from "../../redux/slices/appconfigSlice";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { GetStaticPageContent } from "../../services/StaticContentService";

const PrivacyPolicy = () => {
    const url = window.location.href;
    const {T} = useTranslationCustom();
    const objUrl = new URL(url);
    const searchParams = new URLSearchParams(objUrl.search);
    const urlLocale = searchParams.get("locale");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loginConfig = useSelector(getLoginConfig);
    const [htmlContent, setHtmlContent] = useState('');

    const scrollToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    };

    useEffect(() => {
        scrollToTop();
        if (urlLocale !== loginConfig?.locale?.code) {
            navigate(`/privacy-policy/query?locale=${loginConfig?.locale?.code}&external=${false}`, {replace: true});
        }
        getStaticContent(loginConfig?.locale);
    }, []);

    const getStaticContent = async (language) => {
        try {
            dispatch(setActivityIndicator(true));
            // Goes through HttpClient so the auth token, loading state and
            // cancellation are handled by the shared interceptors.
            setHtmlContent(await GetStaticPageContent("privacy_policy", language));
            dispatch(setActivityIndicator(false));
        } catch (e) {
            console.error('static page error', e);
            dispatch(setActivityIndicator(false));
        }
    }

    return (
        <div className="static-page privacy-policy">
            <div className="main-wrapper">
                <div className="container">
                    <AppHeader/>
                    <main className="body-wrapper">
                        <div className="left-action-back-btn">
                            <a onClick={() => navigate(-1)}>{T("Buttons:Back")}</a>
                        </div>
                        <h2 className="text-center">{htmlContent?.title}</h2>
                        <div
                            dangerouslySetInnerHTML={{__html: htmlContent?.content}}
                        />
                    </main>
                </div>
                <Footer/>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
